export default {
      id: "ic_play_circle-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_play_circle-usage",
      toString: function () {
        return this.url;
      }
    }